const createImageSet = (images) => {
  const baseImage = images[0];
  return images
    .map(({ width, src }) => {
      const multiplier = width / baseImage.width;
      if (Number.isInteger(multiplier)) {
        return `url("${src}") ${multiplier}x`;
      }
      return null;
    })
    .filter((x) => Boolean(x))
    .join(",");
};

const imageSetCss = (images) => {
  if (images.length > 0) {
    return [
      `background-image:url("${images[0].src}");`,
      `background-image:image-set(${createImageSet(images)});`,
    ].join("");
  }
  return ``;
};

export const backgroundImageCss = ({ aspectRatio = 1, srcSetWebp = "" }) => {
  const parseSrcSetItem = (item) =>
    (([src, size]) => ({ src, width: parseInt(size) }))(item.split(" "));
  const images = srcSetWebp
    .split(",\n")
    .filter((x) => Boolean(x))
    .reduce((images, item) => {
      const { src, width } = parseSrcSetItem(item);
      images.push({
        src,
        width,
        height: Math.round(width / aspectRatio),
      });
      return images;
    }, []);

  return [
    `${imageSetCss(images.slice(-1))}`,
    ...images
      .map(({ width, height }, i) => {
        return `@media(max-width: ${width}px) and (max-height: ${height}px){${imageSetCss(
          images.slice(i)
        )}};`;
      })
      .reverse(),
  ].join("");
};
